/**
 * WHERE THE API IS — one read of one build-time variable, for the whole web app.
 *
 * ⚠️ HOISTED AT THE FOURTH OCCURRENCE, WHICH IS THREE TOO LATE. `api.ts`, `export.ts` and
 * `import.ts` each declared their own `API_URL` with their own trailing-slash trim; the join
 * screen would have been the fourth. The DRY rule hoists a FACT at the first duplicate, and the
 * API's address is as plain a fact as this app has.
 *
 * ⚠️ `VITE_` MEANS BUILD TIME. This is inlined by Vite at build, not read at boot, so changing
 * it requires a redeploy — the standing note in CLAUDE.md. Reading it in one place does not
 * change that; it just means there is one place to look when it is wrong.
 */
const API_URL = (import.meta.env.VITE_API_URL as string | undefined)?.replace(/\/+$/, '');

/** The configured origin, or undefined. Callers must handle undefined — an unconfigured build
 *  is a real state that the Diagnostics screen reports rather than a crash. */
export function apiBaseUrl(): string | undefined {
  return API_URL;
}

export function apiConfigured(): boolean {
  return Boolean(API_URL);
}
